export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const WOOT_PREFIX = 'chatwoot-widget:';
// AegisChat: branded postMessage prefix. The SDK asks for it with ?sdk_v=2 on the
// iframe URL; SDK builds cached before that only understand WOOT_PREFIX.
export const AEGIS_PREFIX = 'aegischat-widget:';
export const SDK_PREFIX_PARAM = 'sdk_v';
